import React from "react"
import { Link } from "gatsby"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"

import Img from "gatsby-image"
import ArrowRight from "../../../images/arrow-right.svg"

export default function MilkshakeCakeBatterCup(props) {
  const images = useStaticQuery(graphql`
    query cupImageMilkshakeCakeBatterCup {
      cupImageLarge: file(
        relativePath: { eq: "front-page-flavors/milkshake-cake-batter.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 320) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageMedium: file(
        relativePath: { eq: "front-page-flavors/milkshake-cake-batter.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 260) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      cupImageSmall: file(
        relativePath: { eq: "front-page-flavors/milkshake-cake-batter.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 180) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const cupSources = [
    images.cupImageLarge.childImageSharp.fluid,
    {
      ...images.cupImageMedium.childImageSharp.fluid,
      media: `(max-width: 768px)`,
    },
    {
      ...images.cupImageSmall.childImageSharp.fluid,
      media: `(max-width: 540px)`,
    },
  ]

  return (
    <>
      <Img fluid={cupSources} />
      <div className="flavor-label">
        <h2>Cake Batter Milkshake</h2>
        <Link to="/flavors" state={{ flavor: "milkshakeCakeBatter" }}>
          Check out the details
          <ArrowRight />
        </Link>
      </div>
    </>
  )
}

const Svg = styled.svg`
  .active-bg-1 {
    transition: all 0.2s ease-in-out;
    opacity: ${props => (props.active ? 1 : 0)};
  }

  .border {
    transition: all 0.2s ease-in-out;
    fill: ${props => (props.active ? "#862886" : props.theme.color.primary)};
  }
`
export function MilkshakeCakeBatterThumb(props) {
  const { active } = props

  return (
    <>
      {/* Cake! */}
      <Svg
        version="1.1"
        viewBox="0 0 146 146"
        xmlns="http://www.w3.org/2000/svg"
        active={active}
      >
        <path
          className="active-bg-1"
          d="m101.95 87.169v24.331h-59.013v-24.331h59.013zm-6.0132-21.591v20h-48v-20h48zm-35.088-12.18v9.4873h-5.1724v-9.4873h5.1724zm28.843 0v9.4873h-5.1724l3e-4 -9.4873h5.1721zm-14.436-5.2103v14.39h-5.1724l1e-4 -14.39h5.1723z"
          fill="#FFEFBC"
        />
        <path
          className="active-bg-1"
          d="m58.459 39.729c0.86191 1.0979 1.4488 2.386 1.7117 3.7568 0 0.94007-0.76208 1.7022-1.7022 1.7022s-1.7022-0.76208-1.7022-1.7022c0.2329-1.2559 0.74011-2.4434 1.4838-3.4784l0.20885-0.27843zm28.636-1e-3c0.86191 1.0983 1.4488 2.3867 1.7116 3.7578 0 0.94021-0.76219 1.7024-1.7024 1.7024s-1.7024-0.76219-1.7024-1.7024c0.23306-1.2562 0.74042-2.444 1.4842-3.4793l0.20899-0.27851zm-14.436-4.6612l0.20961 0.27754c0.74808 1.035 1.2616 2.2223 1.5029 3.4793 0 0.94021-0.76219 1.7024-1.7024 1.7024s-1.7024-0.76219-1.7024-1.7024c0.23287-1.2562 0.74007-2.444 1.4837-3.4793l0.20855-0.27752z"
          fill="#F7DB6B"
        />
        <path
          className="active-bg-1"
          d="m103.03 86.214v9.7371c-2.7228 1.6576-4.7666 2.4864-6.1315 2.4864-1.3649 0-3.3114-1.0173-5.8395-3.052-2.7417 2.0346-4.8047 3.052-6.189 3.052s-3.4574-1.0173-6.2195-3.052c-2.5473 2.0346-4.54 3.052-5.9782 3.052s-3.5817-1.0173-6.4304-3.052c-2.6129 2.0346-4.6353 3.052-6.0674 3.052s-3.5667-1.0173-6.404-3.052c-2.7313 2.0346-4.7767 3.052-6.1364 3.052-1.3006 0-3.1101-0.7583-5.4285-2.2749l-0.3193-0.21151v-9.7371h61.144zm-6.1315-21.388v9.3527c-2.5059 2.0455-4.4524 3.0682-5.8395 3.0682s-3.4501-1.2474-6.189-3.7421l-0.58005 0.51549c-2.4683 2.1511-4.3481 3.2266-5.6395 3.2266-1.3907 0-3.4679-1.2474-6.2316-3.7421-2.7106 2.4947-4.7697 3.7421-6.1771 3.7421s-3.4728-1.2474-6.196-3.7421c-2.8279 2.4947-4.9197 3.7421-6.2754 3.7421-1.3014 0-3.1448-0.94256-5.5301-2.8277l-0.30099-0.24055v-9.3527h48.959z"
          fill="#E06EAA"
        />
        <path
          className="border"
          d="m76.754 45.188c0.82843 0 1.5 0.67157 1.5 1.5l-9e-4 16.197h3.264l5e-4 -10.987c0-0.82843 0.67157-1.5 1.5-1.5h8.1721c0.82843 0 1.5 0.67157 1.5 1.5l-6e-4 10.987 4.5576 6e-4c0.82843 0 1.5 0.67157 1.5 1.5l-6e-4 19.783 4.7022 2e-4c0.82843 0 1.5 0.67157 1.5 1.5v27.331c0 0.82843-0.67157 1.5-1.5 1.5h-62.013c-0.82843 0-1.5-0.67157-1.5-1.5v-27.331c0-0.82843 0.67157-1.5 1.5-1.5l4.701-2e-4 6e-4 -19.783c0-0.82843 0.67157-1.5 1.5-1.5l5.0374-6e-4 2e-4 -10.987c0-0.82843 0.67157-1.5 1.5-1.5h8.1724c0.82843 0 1.5 0.67157 1.5 1.5l-6e-4 10.987h3.235l5e-4 -16.197c0-0.82843 0.67157-1.5 1.5-1.5h8.1724zm1.9054 51.644c-1.3994 1.9088-3.6577 3.1487-6.2058 3.1515-2.5479-0.0031404-4.8059-1.2431-6.206-3.1517-1.4 1.9088-3.6581 3.1487-6.2061 3.1517-2.548-0.0030081-4.8061-1.2429-6.2063-3.1515-1.3994 1.9087-3.6575 3.1485-6.2055 3.1515-1.7681-0.0020874-3.3966-0.59974-4.6957-1.6032l0.0011032 13.12h59.014v-13.12c-1.2988 1.003-2.9268 1.6004-4.6943 1.6027-2.541-0.002868-4.7938-1.2359-6.1949-3.1356-1.4001 1.8996-3.6528 3.1326-6.1938 3.1356-2.548-0.0030081-4.8061-1.2429-6.2063-3.1515zm23.289-9.663h-59.013l-0.0014391 7.6523c1.1454 1.3005 3.036 2.1622 4.6961 2.1622 2.5926 0 4.6944-2.1017 4.6944-4.6944 0-0.7797 0.59489-1.4204 1.3555-1.4931l0.16756-0.0068666c0.82843 0 1.5 0.67157 1.5 1.5 0 2.5926 2.1017 4.6944 4.6944 4.6944s4.6944-2.1017 4.6944-4.6944c0-0.7797 0.59489-1.4204 1.3555-1.4931l0.16826-0.0069666c0.82843 0 1.5 0.67157 1.5 1.5 0 2.5926 2.1017 4.6944 4.6944 4.6944s4.6944-2.1017 4.6944-4.6944c0-0.7797 0.59489-1.4204 1.3555-1.4931l0.16746-0.0067666c0.82843 0 1.5 0.67157 1.5 1.5 0 2.5926 2.1017 4.6944 4.6944 4.6944s4.6944-2.1017 4.6944-4.6944c0-0.19492 0.03718-0.38116 0.10484-0.55202l0.055951-0.12525c0.24742-0.48821 0.75404-0.82284 1.3388-0.82284 0.19492 0 0.38116 0.03718 0.55202 0.10484l0.12555 0.056451c0.26359 0.13359 0.48241 0.34273 0.62797 0.59894 0.12374 0.2186 0.19447 0.47092 0.19447 0.73977 0 2.5925 2.1016 4.6941 4.6941 4.6941 1.6518 0 3.5419-0.83802 4.6961-2.1168l-0.001569-7.6974zm-17.098-11.543c-1.3994 1.908-3.6569 3.1474-6.2042 3.1504-2.5472-0.0030084-4.8047-1.2424-6.2045-3.1504-1.3991 1.908-3.6565 3.1474-6.2037 3.1504-2.5473-0.0029751-4.8048-1.2424-6.2047-3.1504-1.3993 1.908-3.6567 3.1474-6.204 3.1504-1.7674-0.0020873-3.3952-0.5994-4.6939-1.6022l8.816e-4 6.9946h46.611v-6.9936c-1.2985 1.0022-2.9258 1.5991-4.6925 1.6012-2.5472-0.0030084-4.8047-1.2424-6.2045-3.1504zm10.897-9.7402h-46.611v7.8411c1.1964 1.2368 3.0819 2.0485 4.6928 2.0485 2.5915 0 4.6924-2.1009 4.6924-4.6924 0-0.7797 0.59489-1.4204 1.3555-1.4931l0.16786-0.0068666c0.82843 0 1.5 0.67157 1.5 1.5 0 2.5917 2.101 4.6926 4.6926 4.6926s4.6926-2.101 4.6926-4.6926c0-0.7797 0.59489-1.4204 1.3555-1.4931l0.16786-0.0068666c0.82843 0 1.5 0.67157 1.5 1.5 0 2.5917 2.101 4.6926 4.6926 4.6926s4.6926-2.101 4.6926-4.6926c0-0.7797 0.59489-1.4204 1.3555-1.4931l0.16786-0.0068666c0.82843 0 1.5 0.67157 1.5 1.5 0 1.6764 0.89437 3.2255 2.3462 4.0637 1.4518 0.83822 3.2406 0.83822 4.6924 0 0.74544-0.43038 1.6463-1.0482 2.3465-1.7744v-7.4866zm-6.0577-12.487h-5.1721l-3e-4 9.4873h5.1724v-9.4873zm-28.843 0h-5.1724v9.4873h5.1724v-9.4873zm14.407-5.2103h-5.1723l-1e-4 14.39h5.1724v-14.39zm11.85-12.324c1.6655 0 4.7021 5.3447 4.7021 7.6221-0.0029758 2.5957-2.1064 4.6991-4.7021 4.7021-2.5958-0.0027553-4.6996-2.1063-4.7026-4.7021 0-2.3613 3-7.6221 4.7026-7.6221zm-28.636 0c1.6655 0 4.7021 5.3447 4.7021 7.6221-0.0029758 2.5957-2.1064 4.6991-4.7021 4.7021-2.5957-0.0029758-4.6991-2.1064-4.7021-4.7021 0-2.3613 3-7.6221 4.7021-7.6221zm28.626 3.8642c-0.85827 1.0984-1.439 2.3874-1.6932 3.7578 0 0.94021 0.76219 1.7024 1.7024 1.7024s1.7024-0.76219 1.7024-1.7024c-0.26285-1.3711-0.84969-2.6595-1.7116-3.7578zm-28.636 1e-3c-0.858 1.0981-1.4385 2.3867-1.6926 3.7568 0 0.94007 0.76208 1.7022 1.7022 1.7022s1.7022-0.76208 1.7022-1.7022c-0.26291-1.3708-0.84979-2.6589-1.7117-3.7568zm14.21-8.5283c1.6655 0 4.7021 5.3447 4.7021 7.623-0.0029758 2.5957-2.1064 4.6991-4.7021 4.7021-2.5958-0.0027553-4.6996-2.1063-4.7026-4.7021 0-2.3623 3-7.623 4.7026-7.623zm-0.0103 3.8652c-0.85754 1.0983-1.4381 2.3873-1.6921 3.7577 0 0.94021 0.76219 1.7024 1.7024 1.7024s1.7024-0.76219 1.7024-1.7024c-0.26321-1.3712-0.85043-2.6596-1.7127-3.7577z"
          fill="#862886"
        />
      </Svg>
    </>
  )
}
